/* eslint-disable max-classes-per-file */
import { ObjectUtils } from "../utils/object-utils";

export class DataExport {
    private readonly rows: ExcelRow[] = [];
    private readonly separator: string;

    constructor(separator = "\t") {
        this.separator = separator;
    }

    addRow(act: (row: ExcelRow) => void) {
        const row = new ExcelRow();
        act(row);
        this.rows.push(row);
    }

    addEmptyRow() {
        this.rows.push(new ExcelRow());
    }

    setToClipboard(onComplete: () => void) {
        const str = this.rows
            .map(r => r.cells.join(this.separator))
            .join("\n");

        ObjectUtils.copyToClipboard(str);

        onComplete();
    }
}

export class ExcelRow {
    readonly cells: (string | number)[] = [];
    addCell(cell: string | number) {
        this.cells.push(cell);
    }
}
